import { type FC, type ReactNode } from 'react';
import clsx from 'clsx';
import type { ThreatLevel } from '@/types';

// ---------------------------------------------------------------------------
// Severity badge — color-coded by threat level
// ---------------------------------------------------------------------------

interface BadgeProps {
  level: ThreatLevel;
  children?: ReactNode;
  className?: string;
}

const BADGE_CLASS: Record<ThreatLevel, string> = {
  critical: 'badge-critical',
  high: 'badge-high',
  medium: 'badge-medium',
  low: 'badge-low',
  info: 'badge-info',
};

export const Badge: FC<BadgeProps> = ({ level, children, className }) => (
  <span className={clsx('badge', BADGE_CLASS[level], className)}>
    {children ?? level.charAt(0).toUpperCase() + level.slice(1)}
  </span>
);
